module.exports = __webpack_public_path__ + "img/flag.05daaf4e.svg";